"use client";

import { AdSlot } from "./AdSlot";

type MatchmakingModeProps = {
  mode: "casual" | "ranked";
  onBack: () => void;
  onOpenCasual: () => void;
};

const copy = {
  casual: {
    title: "カジュアルマッチ",
    kicker: "CASUAL MATCH",
    lead: "自動マッチングを準備中です",
    detail: "現在はカスタムルームやマルチルームで対戦できます。匿名の自動マッチングはサーバー機能追加後に開放します。",
  },
  ranked: {
    title: "ランクマッチ",
    kicker: "RANKED MATCH",
    lead: "レート対戦を準備中です",
    detail: "ランク戦にはアカウント、対戦結果の保存、不正対策が必要です。安全に運用できる基盤を整えてから開放します。",
  },
} as const;

export function MatchmakingMode({ mode, onBack, onOpenCasual }: MatchmakingModeProps) {
  const selected = copy[mode];

  return (
    <main className="mode-shell matchmaking-shell">
      <header className="mode-header">
        <button className="back-button" onClick={onBack} type="button">← メニュー</button>
        <span className="mode-header-label">{selected.kicker}</span>
      </header>

      <section aria-labelledby="matchmaking-title" className="matchmaking-card">
        <span aria-hidden="true" className="matchmaking-emblem">{mode === "ranked" ? "★" : "✦"}</span>
        <span className="mode-badge">COMING SOON / 準備中</span>
        <h1 id="matchmaking-title">{selected.title}</h1>
        <p className="matchmaking-lead">{selected.lead}</p>
        <p className="matchmaking-detail">{selected.detail}</p>
        <button className="matchmaking-cta" onClick={onOpenCasual} type="button">
          カジュアルマッチで今すぐ対戦
        </button>
      </section>

      <AdSlot format="horizontal" label="マッチ画面の広告スペース" />
    </main>
  );
}
